import { MatchEventType } from 'shared/types/match-event';
import { ShootoutAttempt, ShootoutAttempts } from 'shared/types/shootout';

/**
 * Единственное место, где решается «это удар серии пенальти».
 *
 * Признак — тип события, а не период. Период серии в хронологии записан нулём
 * (протокол матча так и подписывает его «Серия пенальти»), но панель управления
 * трансляцией позволяет докрутить счётчик до «настоящего» номера серии, и тогда
 * по периоду серию не опознать. Тип же приходит один и тот же в обоих случаях.
 */
const SHOOTOUT_EVENT_TYPES: Record<string, ShootoutAttempt> = {
  AFTER_MATCH_PENALTY_GOAL: 'GOAL',
  AFTER_MATCH_PENALTY_MISSED: 'MISS',
};

/** Исход удара серии или `undefined`, если событие к серии не относится. */
export function toShootoutAttempt(type: MatchEventType): ShootoutAttempt | undefined {
  return SHOOTOUT_EVENT_TYPES[type];
}

export function isShootoutEvent(event: { type: MatchEventType }): boolean {
  return toShootoutAttempt(event.type) !== undefined;
}

/**
 * Новая пустая раскладка ударов. Именно функция, а не общая константа: массивы
 * попадают в состояние Redux, и общий объект мутировался бы всеми матчами сразу.
 */
export function emptyShootoutAttempts(): ShootoutAttempts {
  return { first: [], second: [] };
}

export function countShootoutAttempts(attempts: ShootoutAttempt[], outcome: ShootoutAttempt): number {
  return attempts.filter((attempt) => attempt === outcome).length;
}
